import mapImage from '../../public/images/map.svg';

export interface MapImageButtonProps {
    onClick: () => void;
    latitude?: number;
    longitude?: number;
    showPin?: boolean;
    zoom?: number;
    buttonText?: string;
    className?: string;
}

export const MapImageButton = ({
    onClick,
    latitude,
    longitude,
    zoom = 11,
    showPin = false,
    buttonText = 'Vis kart',
    className = '',
}: MapImageButtonProps) => {
    const imageUrl =
        latitude && longitude
            ? `https://maptiles.finncdn.no/staticmap?lat=${latitude}&lng=${longitude}&zoom=${zoom}&maptype=norwayVector&showPin=${showPin}&size=590x194`
            : mapImage.src;

    return (
        <div className={`map-image-button ${className}`}>
            <img src={imageUrl} alt="Vis i kart" className="image-frame u-size1of1 clickable" onClick={onClick} />
            <button type="button" data-testid="map-button" className="button button--small button--utility map-button" onClick={onClick}>
                <i className="icon icon--medium icon--pin" />
                <div>{buttonText}</div>
            </button>
        </div>
    );
};
